import React from "react";
import extractCurrentUserData from "./ExtractCurrentUser";
import { UserInfo } from "../types";

interface CurrentUserProps {
  userInfo?: UserInfo | null;
}

const CurrentUser: React.FC<CurrentUserProps> = ({ userInfo }) => {
  const { name, userName } = extractCurrentUserData();

  if (!userInfo) {
    return <p>Not Logged in</p>;
  }

  return (
    <div>
      {userName ? (
        <>
          <p>You are currently logged in as:</p>
          <p>
            <strong>{userInfo.username}</strong>
            <br />
            <strong>{userInfo.email}</strong>
          </p>
        </>
      ) : (
        <p>Not Logged in</p>
      )}
    </div>
  );
};

export default CurrentUser;
